<template>
    <div>
        <spinner-component v-if="loading" :loading="loading" />

        <div v-else>
            <h3 class="tx-color-01">Login</h3>
            <p class="tx-color-03 mg-b-30">Please select your email to login.</p>
            <form method="POST" action="/login" @submit.prevent="login">
                <div class="form-group">
                    <label>Email Address</label>
                    <select v-model="form.user_id" id="client" class="custom-select shadow-sm"
                        :class="{ 'is-invalid': form.errors.has('external_client_id') }">
                        <option :value="null" disabled>Select your email</option>
                        <option v-for="(type, index) in companyEmails" :value="type.user_id" :key="index">
                            {{ maskEmail(type.email) }}
                        </option>
                    </select>
                    <has-error :form="form" field="email"></has-error>
                </div>
                <button-component :busy="form.busy" :label="'Sign in'" :label-loading="'Please wait..'"
                    :button-class="'btn btn-default btn-block'"></button-component>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.$store.dispatch("clearLocalStorage");
        this.fetchData()
    },
    data: function () {
        return {
            companyEmails: [],
            loading: true,
            form: new Form({
                user_id: null,
            })
        };
    },
    methods: {
        fetchData() {
            const { params, query } = this.$route
            this.loading = true

            axios.get(`/api/auth/company-login/${params.company}/users`, { query })
                .then(({ data: { data } }) => {
                    this.company = data.company
                    this.companyEmails = data.users
                })
                .catch(({ response }) => console.log(response))
                .finally(() => this.loading = false)
        },
        maskEmail(email) {
            const [name, domain] = email.split('@');
            const maskedName = name.slice(0, 3) + '*'.repeat(name.length - 5) + name.slice(-2);
            return `${maskedName}@${domain}`;
        },
        login() {
            const { params } = this.$route

            this.form.post(`/api/auth/company-login/${params.company}/authenticate`)
                .then(({ data: { data } }) => {
                    if (data.user && data.token) {
                        this.$store.dispatch('setLocalStorage', {
                            user: JSON.stringify(data.user),
                            token: data.token
                        });

                        window.location = data.intended;
                    }
                });
        }
    }
};
</script>
